module.exports = __webpack_public_path__ + "static/dell-0dee337049b38df74046c6957a32bd46.png";